import { Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { CmsImagesProvider } from './context/CmsImagesContext';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import BusinessCleaning from './pages/BusinessCleaning';
import PrivateCleaning from './pages/PrivateCleaning';
import About from './pages/About';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';

export default function App() {
  return (
    <LanguageProvider>
      <CmsImagesProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tjenester" element={<Services />} />
          <Route path="/erhvervsrengoring" element={<BusinessCleaning />} />
          <Route path="/privatrengoring" element={<PrivateCleaning />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/galleri" element={<Gallery />} />
          <Route path="/nyheder" element={<News />} />
          <Route path="/nyheder/:slug" element={<NewsDetail />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </CmsImagesProvider>
    </LanguageProvider>
  );
}
